import React from 'react';
import {
  Box,
  Text,
  Textarea,
  FormControl,
  FormLabel,
  Input,
  Flex,
} from '@chakra-ui/react';
import ProfileImageUploader from './ProfileImageUploader';

const BIO_MAX_LENGTH = 300;

const inputStyles = {
  bg: '#202225',
  borderColor: 'gray.600',
  _hover: { borderColor: 'gray.500' },
  _focus: { borderColor: 'yellow.400', boxShadow: '0 0 0 1px #ECC94B' },
};

const ProfileHeaderSection = ({
  currentDraft,
  currentProfile,
  onDraftChange,
  onImageChange,
  onRemoveImage,
  uploadingImage,
}) => {
  const bioLength = (currentDraft?.bio || '').length;

  return (
    <Box>
      <Flex
        direction={{ base: 'column', sm: 'row' }}
        align={{ base: 'center', sm: 'flex-start' }}
        gap={{ base: 4, sm: 5 }}
        mb={6}
      >
        <ProfileImageUploader
          profileImageUrl={currentProfile?.profileImageUrl}
          alt={currentDraft?.fullName || 'Immagine profilo'}
          onImageChange={onImageChange}
          onRemoveImage={onRemoveImage}
          uploading={uploadingImage}
          size={{ base: '96px', md: '112px' }}
        />
        <Box flex="1" w="full">
          <FormControl>
            <FormLabel fontSize="sm">Nome visibile nel Network</FormLabel>
            <Input
              value={currentDraft?.fullName || ''}
              onChange={(e) => onDraftChange('fullName', e.target.value)}
              placeholder="Es. Mario Rossi"
              fontSize={{ base: 'md', md: 'lg' }}
              fontWeight="semibold"
              _placeholder={{ color: 'gray.500' }}
              {...inputStyles}
            />
          </FormControl>
        </Box>
      </Flex>

      <FormControl>
        <FormLabel fontSize="sm">Biografia</FormLabel>
        <Text fontSize="xs" color="gray.500" mb={2}>
          Descrivi chi sei e cosa fai — è la prima cosa che leggono gli altri.
        </Text>
        <Textarea
          value={currentDraft?.bio || ''}
          onChange={(e) => onDraftChange('bio', e.target.value)}
          maxLength={BIO_MAX_LENGTH}
          rows={4}
          placeholder="Raccontati in poche righe..."
          {...inputStyles}
        />
        <Text fontSize="xs" color="gray.400" mt={1} textAlign="right">
          {bioLength}/{BIO_MAX_LENGTH}
        </Text>
      </FormControl>
    </Box>
  );
};

export default ProfileHeaderSection;
export { BIO_MAX_LENGTH };
